// extracted by mini-css-extract-plugin
export default {"page_list":"index_page_list_ath-b clearfix","current":"index_current_-rnGX"};